import { cx } from "@jugl-web/utils";
import { FC, ReactNode, useMemo, useState } from "react";
import { LiveChatUIContext } from "../LiveChatUIContext";

export interface LiveChatUIRootProps {
  children: ReactNode;
  className?: string;
}

export const LiveChatUIRoot: FC<LiveChatUIRootProps> = ({
  children,
  className,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const contextValue = useMemo(
    () => ({
      isSidebarOpen,
      openSidebar: () => setIsSidebarOpen(true),
      closeSidebar: () => setIsSidebarOpen(false),
    }),
    [isSidebarOpen]
  );

  return (
    <LiveChatUIContext.Provider value={contextValue}>
      <div
        className={cx("flex h-full w-full overflow-hidden bg-white", className)}
      >
        {children}
      </div>
    </LiveChatUIContext.Provider>
  );
};
